import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth(); 
    if (!isAuthenticated) {
        // Redirect them to the login page
        return <Navigate to="/" />;
    }

    return children;
};

export default ProtectedRoute;
